module.exports = __webpack_public_path__ + "media/images/top/top-ogp-9d279ce48350b1689e98dc2785a548fc.png";